import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=7363b7e8&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"
import style0 from "./Collection.vue?vue&type=style&index=0&id=7363b7e8&prod&scoped=true&lang=css"
import style1 from "./Collection.vue?vue&type=style&index=1&id=7363b7e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7363b7e8",
  null
  
)

export default component.exports